import { render } from "./RequestAQuote.vue?vue&type=template&id=6a9d129b&scoped=true"
import script from "./RequestAQuote.vue?vue&type=script&lang=js"
export * from "./RequestAQuote.vue?vue&type=script&lang=js"

import "./RequestAQuote.vue?vue&type=style&index=0&id=6a9d129b&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9d129b"]])

export default __exports__